<template>
  <div class="body-main-container">
    <div class="login-main-container">
      <div class="imagelogin-container">
        <img src="../assets/loginimage.webp" alt="Imagen de Login" style="width: 100%; height: 100%; border-top-left-radius: 10px; border-bottom-left-radius: 10px; filter: brightness(90%) contrast(105%);">
      </div>
      <div class="contentmain-container">
        <div class="d-flex align-items-center mb-4">
          <img src="../assets/logobaessh.svg" alt="Logo Baessh" style="width: 3rem; margin-right: 0.5rem;">
          <span class="brand-text font-weight-light" style="font-size: 1.5rem;">BAESSH</span>
        </div>
        <div class="mb-4">
          <div class="alert alert-danger" role="alert" v-if="errorMessage">
            {{ errorMessage }}
          </div>
          <span v-else><b>Recupera tu cuenta</b></span>
        </div>
        <form @submit.prevent="recuperacion()" v-if="enviado">
          <div>
            <p>Ingresa tu correo electrónico <i 
              class="fa fa-info-circle text-primary m-1"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Correo electrónico registrado en BAESSH en el que se enviaron las instrucciones del acceso al portal.">
            </i> o usuario</p> 
          </div>
          <div class="input-group mb-3">
            <input id="rfc" type="text" class="form-control" name="rfc" v-model="credencial" required autocomplete="email" autofocus placeholder="Usuario o correo">
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fa fa-user" style="font-size: 18px;"></span>
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-secondary" :disabled="loading">
            <span
              v-if="loading"
              class="spinner-border spinner-border-sm mr-2"
              role="status"
              aria-hidden="true"
            ></span>
            {{ loading ? 'Enviando...' : 'Enviar' }}
          </button>
          <!-- //Agregar link para regresar a la pagina de inciiar sesion -->
          <div class="mt-3">
            <router-link to="/" class="btn btn-link" style="text-decoration: none; font-weight: 700; font-size: 13px"><i class="fa fa-solid fa-arrow-left"></i> Volver a iniciar sesión</router-link>
          </div>
        </form>
        <div v-else>
          <p style="padding: 1rem;">Si la cuenta existe, recibirás un correo con instrucciones para restablecer tu contraseña.</p>
          <router-link  to="/" class="btn btn-secondary" >Continuar</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosInstance from '../services/axiosInstance'
import { Tooltip } from "bootstrap";
export default {
  data(){
    return{
      credencial: '',
      errorMessage: '',
      enviado: true,
      loading: false
    }
  },
  name: 'LoginPage', 
  methods: {
    async recuperacion(){
      if (this.loading) return;

      this.loading = true;
      this.errorMessage = '';

      try {
        await axiosInstance.post('/users/recuperacion', { dato: this.credencial });
        this.enviado = false;
      } catch (error) {
        this.errorMessage = 'Ocurrio un error inesperado';
      } finally {
        this.loading = false;
      }
    }
  },
  mounted(){
    new Tooltip(document.body, {
    selector: "[data-bs-toggle='tooltip']",
    });
  },
};
</script>

<style>
.body-main-container{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  background: linear-gradient(to left, #774d1b 14%, #182579 86%);
}
.login-main-container {
  width: 50%;
  display: flex;
  flex-wrap: wrap;
  background-color: white;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.2), -4px -4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

.imagelogin-container{
  width: 40%;
}
.contentmain-container{
  width: 60%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 3rem 0;
}


  
@media (max-width: 950px) {
  .imagelogin-container{
    display: none;
  }
  .contentmain-container{
    width: 100%;
    padding: 1rem;
  }
  .login-main-container{
    width: 70%;
  }

}
</style>
